import { IErrorStatus } from "../interfaces/ierrorstatus";

import * as errorStatusActions from "../actions/errorstatus.action";

const initialState: IErrorStatus = {
    notfound: false,
    servererror: false,
    badrequest: false
};

export function errorStatusReducer(state: IErrorStatus = initialState,
    action: errorStatusActions.Actions): IErrorStatus {

    switch (action.type) {
        case errorStatusActions.actionTypes.SET_NOTFOUND :
            return {
                ...state,
                notfound: true
            };
        case errorStatusActions.actionTypes.RESET_NOTFOUND:
            return {
                ...state,
                notfound: false
            };
        case errorStatusActions.actionTypes.SET_SERVERERROR:
            return {
                ...state,
                servererror: true
            };
        case errorStatusActions.actionTypes.RESET_SERVERERROR:
            return {
                ...state,
                servererror: false
            };
        case errorStatusActions.actionTypes.SET_BADREQUEST:
            return {
                ...state,
                badrequest: true
            };
        case errorStatusActions.actionTypes.RESET_BADREQUEST:
            return {
                ...state,
                badrequest: false
            };
        default:
            return state;
    }
}